import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from '../../../services/session.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-confirmar-clave',
  templateUrl: './confirmar-clave.component.html'
})
export class ConfirmarClaveComponent implements OnInit {
  
  dataForm: FormGroup;

  codigoVerificador: string;

  disabled:boolean = false;

  
  constructor(private service: SessionService, private toastr: ToastrService,
    private fb: FormBuilder, private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.params.subscribe(params => {
      this.codigoVerificador = params.uuid;
    })
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.dataForm = this.fb.group({
      password: ['', Validators.required],
      passwordRepeat: ['', Validators.required]
    })
  }

  confirmar() {
    if (this.dataForm.value.password !== this.dataForm.value.passwordRepeat){
      this.toastr.warning('Contraseñas no coinciden, favor verificar', 'Atención');
      return;
    }
    let data = {
      password: this.dataForm.value.password,
      codigoVerificador: this.codigoVerificador
    }
    this.disabled = true;
    this.service.confirmar(data).subscribe(
      (resp: any) => {
        this.disabled = false;
        this.toastr.success('Clave de usuario cambiado con éxito', 'Éxito');
        this.dataForm.reset();
        this.router.navigate([''],{queryParams: {'hb':'1'}});
      }, err => {
        this.disabled = false;
        this.toastr.error(err.error.messages[0], 'Error');
      }
    );
  }

}
